/**
 * Cart drawer top picks: carousel navigation, variant modal, and quick add.
 */
document.addEventListener('DOMContentLoaded', function () {
  var sidebarCart = document.getElementById('sidebar-cart');

  if (!sidebarCart) {
    return;
  }

  function getCarousel() {
    return sidebarCart.querySelector('[data-cart-top-picks-carousel]');
  }

  function scrollCarousel(direction) {
    var carousel = getCarousel();

    if (!carousel) {
      return;
    }

    carousel.scrollBy({
      left: direction * carousel.clientWidth,
      behavior: 'smooth'
    });
  }

  function formatMoney(cents) {
    if (typeof Currency !== 'undefined' && Currency.formatMoney && window.theme) {
      return Currency.formatMoney(cents, window.theme.moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function getProductData(form) {
    var jsonNode = form.querySelector('[data-product-json]');

    if (!jsonNode) {
      return null;
    }

    try {
      return JSON.parse(jsonNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedOptions(form) {
    var options = [];
    var selectedOptions = form.querySelectorAll('[data-cart-top-pick-option]:checked');

    selectedOptions.forEach(function (input) {
      options[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
    });

    return options;
  }

  function findVariant(product, options) {
    if (!product || !product.variants) {
      return null;
    }

    return product.variants.find(function (variant) {
      return options.every(function (value, index) {
        return variant['option' + (index + 1)] === value;
      });
    });
  }

  function updateModalVariant(form) {
    var product = getProductData(form);
    var options = getSelectedOptions(form);
    var variant = findVariant(product, options);
    var submitButton = form.querySelector('[data-action="cart-top-pick-add"]');
    var priceNode = form.querySelector('[data-cart-top-pick-price]');
    var imageNode = form.querySelector('[data-cart-top-pick-image]');
    var errorNode = form.querySelector('[data-cart-top-pick-error]');

    if (!submitButton || !variant) {
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.removeAttribute('data-variant-id');
      }

      return;
    }

    submitButton.setAttribute('data-variant-id', variant.id);

    if (variant.available) {
      submitButton.removeAttribute('disabled');
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }
    } else {
      submitButton.setAttribute('disabled', 'disabled');
      if (errorNode) {
        errorNode.hidden = false;
        errorNode.textContent = 'Εξαντλημένο';
      }
    }

    if (priceNode) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceNode.innerHTML = '<span class="Price Price--highlight">' + formatMoney(variant.price) + '</span><span class="Price Price--compareAt">' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        priceNode.innerHTML = '<span class="Price">' + formatMoney(variant.price) + '</span>';
      }
    }

    if (imageNode && variant.featured_image) {
      imageNode.src = variant.featured_image.src;
    }
  }

  function initModalForms() {
    sidebarCart.querySelectorAll('[data-cart-top-pick-form]').forEach(function (form) {
      updateModalVariant(form);
    });
  }

  function addVariantToCart(variantId) {
    if (!variantId || !window.routes) {
      return Promise.resolve(false);
    }

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));

    return fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    }).then(function (response) {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || 'Add to cart failed');
        });
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      var closeButton = document.querySelector('.Modal[aria-hidden="false"] [data-action="close-modal"]');

      if (closeButton) {
        closeButton.click();
      }

      return true;
    });
  }

  sidebarCart.addEventListener('click', function (event) {
    var prevButton = event.target.closest('[data-action="cart-top-picks-prev"]');
    var nextButton = event.target.closest('[data-action="cart-top-picks-next"]');
    var addButton = event.target.closest('[data-action="cart-top-pick-add"]');
    var quickAddButton = event.target.closest('[data-action="cart-top-pick-quick-add"]');

    if (prevButton) {
      event.preventDefault();
      scrollCarousel(-1);
      return;
    }

    if (nextButton) {
      event.preventDefault();
      scrollCarousel(1);
      return;
    }

    if (addButton) {
      event.preventDefault();

      var form = addButton.closest('[data-cart-top-pick-form]');
      var errorNode = form ? form.querySelector('[data-cart-top-pick-error]') : null;

      addVariantToCart(addButton.getAttribute('data-variant-id')).catch(function (error) {
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = error.message;
        }
      });
      return;
    }

    if (quickAddButton) {
      event.preventDefault();

      addVariantToCart(quickAddButton.getAttribute('data-variant-id')).catch(function (error) {
        window.alert(error.message);
      });
    }
  });

  sidebarCart.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-top-pick-option]')) {
      return;
    }

    var form = event.target.closest('[data-cart-top-pick-form]');

    if (form) {
      updateModalVariant(form);
    }
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    window.setTimeout(initModalForms, 0);
  });

  initModalForms();
});

document.addEventListener('click', function (event) {
  var openTrigger = event.target.closest('[data-action="open-mwm-sg"]');
  var closeTrigger = event.target.closest('[data-action="close-mwm-sg"]');
  var modal = document.getElementById('mwm_sg-imageModal');

  if (!modal) {
    return;
  }

  if (openTrigger) {
    event.preventDefault();
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return;
  }

  if (closeTrigger || (modal.classList.contains('is-visible') && event.target === modal)) {
    event.preventDefault();
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
});
